import { SHOP_RECEPTION_FETCH_SHOP_ROLES } from 'components/Layout/constants'

export const roles = {
  chooseStoreRoles: SHOP_RECEPTION_FETCH_SHOP_ROLES
}
